export default __webpack_public_path__ + "static/pattern-pink-76c8da09b8cf06791a0936ac550f5910.jpg";